var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 30 31.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.027,5.4H24.719a4.973,4.973,0,0,0-9.427,0H7.308A2.019,2.019,0,0,0,5,7.352V31.913a1.962,1.962,0,0,0,1.973,1.95H33.027A1.962,1.962,0,0,0,35,31.913V7.352A1.962,1.962,0,0,0,33.027,5.4ZM12.258,8.863a1.154,1.154,0,0,1,1.154-1.154h3.969V6.982a2.671,2.671,0,1,1,5.342,0v.785h3.969a1.154,1.154,0,0,1,1.154,1.154V11H12.212Zm16.754,8.65L18.488,28.036,12.442,21.99a1.632,1.632,0,1,1,2.308-2.308l3.762,3.762,8.238-8.238a1.632,1.632,0,0,1,2.308,2.308Z",
    transform: "translate(-5 -2.014)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickups);
export default __webpack_public_path__ + "static/media/pickups.5b46a4d1f25a7aa5bfc4e14df4d06560.svg";
export { ForwardRef as ReactComponent };